import { render, staticRenderFns } from "./PneumoniaCard.vue?vue&type=template&id=6e6fde6d&scoped=true&"
import script from "./PneumoniaCard.vue?vue&type=script&lang=ts&"
export * from "./PneumoniaCard.vue?vue&type=script&lang=ts&"
import style0 from "./PneumoniaCard.vue?vue&type=style&index=0&id=6e6fde6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6fde6d",
  null
  
)

export default component.exports